import { z } from '@repo/schema'
import { GetCountByMonthSchema, GetSummarySchema } from '@repo/schema/analytics'
import { getDataWrapperSchema } from '@repo/schema/data-wrapper'
import { UpFetch } from '@repo/upfetch'

import { createProcedure } from '../../lib/procedure'

export const createAnalyticsRoute = (upFetch: UpFetch) => {
  const p = createProcedure(upFetch)

  return {
    companyAnalytics: p
      .path(z.object({ companyId: z.number() }), p => ['companies', p.companyId, 'analytics'])
      .query(({ path, upFetch }) =>
        upFetch(path, {
          schema: getDataWrapperSchema(
            z
              .object({
                active_loads_count: z.number().nullish(),
                company: z.object({
                  slug: z.string(),
                }),
                completed_loads_count: z.number().nullish(),
              })
              .transform(ctx => {
                if (ctx.company.slug === 'quote-box') {
                  return {
                    ...ctx,
                    completed_loads_count: 0,
                  }
                }

                return ctx
              }),
          ),
        }),
      ),
    newUsers: p
      .path('analytics', 'new-users')
      .input(z.object({ date_from: z.string(), date_to: z.string(), roles: z.string() }))
      .query(({ input, path, upFetch }) =>
        upFetch(path, {
          params: input,
          schema: z.object({
            data: GetCountByMonthSchema.array(),
            summary: GetSummarySchema,
          }),
        }),
      ),
  }
}
